require('./markersMap.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
import { Marker } from 'react-google-maps';
const { MarkerClusterer } = require('react-google-maps/lib/components/addons/MarkerClusterer');
// @utilities
import { formatText } from 'core/i18n';
const { handleMarkerIcon } = require('../helper/mapHelper');

const closeIcon = require('assets/icons/close.svg');

class MarkersMap extends React.Component {
    handleMarkerClick = current => {
        const { onEventMarker } = this.props;
        onEventMarker(current, true);
    };

    handleInfoWindowClick = current => {
        const { onEventMarker } = this.props;
        onEventMarker(current, false);
    };

    render() {
        const { markers, handleAction } = this.props;
        return (
            <MarkerClusterer
                averageCenter
                enableRetinaIcons
                gridSize={80}
                maxZoom={12}
                styles={[
                    {
                        width: 53,
                        height: 53,
                        backgroundPosition: '0 -99999',
                    },
                ]}
            >
                {markers.map((marker, i) => {
                    return (
                        <React.Fragment key={i.toString()}>
                            <Marker
                                position={{ lat: marker.position.lat, lng: marker.position.lng }}
                                key={i}
                                onClick={() => {
                                    this.handleMarkerClick(marker);
                                }}
                                className="my-marker"
                                icon={handleMarkerIcon(marker)}
                            />
                            {marker.openInfoWindow && (
                                <div className="info-window" key={i}>
                                    <div>
                                        <img
                                            src={closeIcon}
                                            className="info-window__close-button"
                                            onClick={() => {
                                                this.handleInfoWindowClick(marker);
                                            }}
                                        />
                                        <h5 className="info-window__title">{marker.title}</h5>
                                        <div className="info-window__subtitle-data">
                                            <p className="info-window__description">{marker.description}</p>
                                            <p className="info-window__distance">{marker.distance}</p>
                                        </div>
                                        <hr className="info-window__separator" />
                                        <div className="info-window__data">
                                            <div>
                                                <div className="info-window__data-adress">
                                                    <p className="info-window__address">
                                                        <i className="icons icons--icon-map-pin-small info-window__address__icon"></i>
                                                        <span className="info-window__data-adress__content">
                                                            {marker.address}
                                                        </span>
                                                    </p>
                                                </div>
                                                <div className="info-window__data-button">
                                                    <button onClick={() => handleAction(marker)}>
                                                        Quiero identificarme aquí
                                                    </button>
                                                </div>
                                            </div>
                                            <p className="info-window__office-hours">
                                                <span className="info-window__office-hours-title">
                                                    {formatText('identity-mapPhone')}{' '}
                                                </span>
                                                {marker.phone}
                                                <br />
                                                <span className="info-window__office-hours-title">
                                                    {formatText('identity-mapOfficeHours')}{' '}
                                                </span>
                                                {formatText('identity-officeHours1', [marker.officeHours1])}
                                                <span className="info-window__office-hours-separator"> | </span>
                                                {formatText('identity-officeHours2', [marker.officeHours2])}
                                                <span className="info-window__office-hours-separator"> | </span>
                                                {formatText('identity-officeHours3', [marker.officeHours3])}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </React.Fragment>
                    );
                })}
            </MarkerClusterer>
        );
    }
}

MarkersMap.propTypes = {
    markers: PropTypes.array.isRequired,
    onEventMarker: PropTypes.func.isRequired,
    handleAction: PropTypes.func.isRequired,
};

MarkersMap.defaultProps = {
    markers: [],
};

export { MarkersMap };
